import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SignupButton } from 'purchase-motions-components/components/PurchaseMotions/SignupButton/SignupButton';
import { isPublicPurchaseMotion } from 'purchase-motions-components/utils/purchaseMotionTypeGuards';
import { PublicPurchaseMotionCTAWrapper } from '../../components/PublicPurchaseMotionCTAWrapper';
import { Screens } from '../../types/PublicNavItem';
import { TRACKING_SOURCES, trackSignupButtonClick } from '../../utils/tracking';
import { buildPublicSeatsRequest } from './publicHsocPurchaseRequest';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/* Narrows purchaseMotions to the public-renderable subset. */
function getPublicHsocMotions(motions) {
  return motions.filter(isPublicPurchaseMotion);
}

/* Public HSOC V2 merch card CTA cluster: FREE gets a signup button, every other
   tier maps its purchaseMotions to PublicPurchaseMotionCTAWrapper. */
export const HsocV2PublicPurchaseMotionContainer = ({
  tierName,
  productApiName,
  motions,
  currencyCode,
  term,
  trackingSource = TRACKING_SOURCES.MERCH_CARD,
  seatsQuantity,
  ctaUse
}) => {
  const isFree = tierName === 'FREE';
  const publicMotions = getPublicHsocMotions(motions);
  if (publicMotions.length === 0 && !isFree) {
    return null;
  }
  const uniqueId = `${trackingSource}-${productApiName}`;
  const purchaseRequest = seatsQuantity !== undefined ? buildPublicSeatsRequest(productApiName, seatsQuantity, currencyCode, term) : undefined;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    inlineSize: "100%",
    children: [isFree && /*#__PURE__*/_jsx(SignupButton, {
      apiName: productApiName,
      trackingData: {
        app: 'pricing-pages',
        source: trackingSource,
        screen: Screens.FLEX_SEATS_AND_CREDITS,
        uniqueId
      },
      onClick: () => trackSignupButtonClick({
        trackingSource,
        screen: Screens.FLEX_SEATS_AND_CREDITS,
        productNames: [productApiName]
      }),
      uiButtonProps: {
        use: ctaUse !== null && ctaUse !== void 0 ? ctaUse : 'primary',
        block: true
      },
      "data-selenium-id": "free-signup-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.merchCard.cta.getStartedFree"
      })
    }), publicMotions.map((motion, index) => /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(PublicPurchaseMotionCTAWrapper, Object.assign({
        purchaseMotion: motion,
        productApiName: productApiName,
        currencyCode: currencyCode,
        paymentTerm: term,
        commitmentTerm: term,
        displayIndex: isFree ? index + 1 : index
      }, ctaUse !== undefined && {
        uiButtonProps: {
          use: ctaUse
        }
      }, motion === 'BUY_TOUCHLESS' && purchaseRequest !== undefined && {
        purchaseRequest
      }, {
        trackingData: {
          app: 'pricing-pages',
          source: trackingSource,
          screen: Screens.FLEX_SEATS_AND_CREDITS,
          uniqueId
        }
      }))
    }, motion))]
  });
};